import { render } from "./CampoPersonalizadoModal.vue?vue&type=template&id=6a194b75&scoped=true&ts=true"
import script from "./CampoPersonalizadoModal.vue?vue&type=script&lang=ts"
export * from "./CampoPersonalizadoModal.vue?vue&type=script&lang=ts"

import "./CampoPersonalizadoModal.vue?vue&type=style&index=0&id=6a194b75&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a194b75"]])

export default __exports__